module.exports = __webpack_public_path__ + "static/media/thumbnail.d3e25470.jpg";